import { faPencil, faStar } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from 'react';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Popover from 'react-bootstrap/Popover';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import { Spinner } from '../../../../../components/Spinner';

function ConsumerPopoverNameForm({
  consumerIsNew,
  consumerFirstName,
  consumerLastName,
  updateConsumer,
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [spinner, setSpinner] = useState(false);

  const [fields, setFields] = useState({
    firstName: consumerFirstName,
    lastName: consumerLastName,
  });

  const handleToggle = () => {
    setIsOpen(!isOpen);
    setFields({ firstName: consumerFirstName, lastName: consumerLastName });
  };

  const handleSave = async () => {
    setSpinner(true);
    await updateConsumer(fields);
    setSpinner(false);
    setIsOpen(false);
  };

  return (
    <OverlayTrigger
      trigger="click"
      placement="bottom-start"
      show={isOpen}
      popperConfig={{ modifiers: [{ name: 'offset', options: { offset: [0, 0] } }] }}
      overlay={
        <Popover className="custom-popover">
          <Popover.Body className="bo-consumer-popover-form-menu">
            <Spinner visible={spinner}>
              <Form.Label className="bo-consumer-popover-form-menu-label">First Name</Form.Label>
              <Form.Control
                type="text"
                className="bo-consumer-popover-form-menu-input bo-w-180"
                value={fields.firstName}
                onChange={e => setFields(prev => ({ ...prev, firstName: e.target.value }))}
              />
              <Form.Label className="bo-consumer-popover-form-menu-label mt-2">
                Last Name
              </Form.Label>
              <Form.Control
                type="text"
                className="bo-consumer-popover-form-menu-input bo-w-180"
                value={fields.lastName}
                onChange={e => setFields(prev => ({ ...prev, lastName: e.target.value }))}
              />
              <div className="mt-2 d-flex justify-content-between">
                <Button className="bo-common-button" onClick={handleSave}>
                  Save
                </Button>
                <Button className="bo-common-button" onClick={handleToggle}>
                  Cancel
                </Button>
              </div>
            </Spinner>
          </Popover.Body>
        </Popover>
      }
    >
      <Button
        onClick={handleToggle}
        className="bo-consumer-popover-form-toggle pb-1 bo-consumer-popover-toggle-form-name"
      >
        {consumerIsNew && <FontAwesomeIcon icon={faStar} size="1x" color="orange" />}
        <p className="bo-consumer-popover-form-toggle-title">
          {`${consumerFirstName} ${consumerLastName}`}
        </p>
        <div
          className={`bo-consumer-popover-form-toggle-icon ${
            isOpen ? 'bo-consumer-popover-form-toggle-icon-active' : ''
          }`}
        >
          <FontAwesomeIcon icon={faPencil} color="#5946A4" size="sm" />
        </div>
      </Button>
    </OverlayTrigger>
  );
}

export default ConsumerPopoverNameForm;
